<template>
  <el-dialog :close-on-click-modal="false" title="选择地址" v-model="isShow" class="mapPickerContainer">
    <div class="contentContainer">

      <!-- 腾讯地图 -->
      <iframe
        ref="iframe"
        id="mapPage"
        width="100%"
        height="600px"
        frameborder="0"
        :src="`https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=SFTBZ-YB5K5-QLBIO-IO5V7-AUEG5-5VBYH&referer=myapp`"
      >
      </iframe>
      <div class="info" v-if="location.name">
        <div class="name">
          {{ location.name }}
        </div>
        <div class="address">
          {{ location.address }}
        </div>
      </div>
    </div>
    <template #footer>
      <div class="flex" style="justify-content: center">
        <el-button v-if="!location.name" type="info" style="width: 200px">确定</el-button>
        <el-button v-else type="primary" style="width: 200px" @click="handleSubmit">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import fetch from '@/plugin/axios'
const props = defineProps({
  value: Boolean
})
const emits = defineEmits(['update:value', 'success'])
const keyword = ref('')
const iframe = ref()
const location = ref({
  name: '',
  lat: 0,
  lng: 0,
  address: ''
})
const isShow = computed({
  get() {
    return props.value
  },
  set(val) {
    emits('update:value', val)
  }
})
const load = () => {
  iframe.value.contentWindow.postMessage('hello', 'https://m.amap.com/picker/')
}

const init = () => {
  location.value = {
    name: '',
    lat: 0,
    lng: 0,
    address: ''
  }
  window.addEventListener('message', handleMessage, false)
}

const clear = () => {
  window.removeEventListener('message', handleMessage)
}

const handleMessage = ({ data, ...res }) => {
  //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
  if (data && data.module == 'locationPicker') {
    location.value.name = data.poiname
    location.value.address = data.poiaddress
    location.value.lat = data.latlng.lat
    location.value.lng = data.latlng.lng
  }
}

const handleSubmit = () => {
  fetch
    .get('boom-center-admin-service/sysAdmin/area-settings/location-info', {
      params: { latitude: location.value.lat, longitude: location.value.lng }
    })
    .then(res => {
      emits('success', {
        ...location.value
      })
      console.log(location.value)
      isShow.value = false
    })
    .catch(err => {
      window.$globalUtil.message.error(err.msg)
    })
}
watch(
  () => props.value,
  val => {
    console.log(val, '==> by chalee')
    val ? init() : clear()
  }
)
</script>
<style lang="less" scoped>
.contentContainer {
  margin-top: -30px;
  margin-bottom: -30px;
  margin-left: -20px;
  margin-right: -20px;
  iframe {
    border-bottom: 1px solid #ebeef5;
  }
  .info {
    background: var(--color-primary);
    color: white;
    display: flex;
    justify-content: space-between;
    padding: 20px;
  }
}
</style>

<style>
.el-dialog__body {
  padding: calc(var(--el-dialog-padding-primary) + 10px) var(--el-dialog-padding-primary);
}
</style>
